import { FlexContainer, palette } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

const ToolbarStyled = styled(FlexContainer)((props) => {
  return {
    position: 'absolute',
    backgroundColor: palette.black.plus100,
    bottom: 0,
    left: 0,
    right: 0,
    height: '48px',
    borderTop: `1px solid ${palette.black.plus70}`,
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  }
})

export default ToolbarStyled
